import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { OkObject } from '@it2go/types';
import {
    InboxAfFileValidationResultObject,
} from '@libs/types/src/inbox/object-type/inbox-af-file-validation-result.object';
import { InboxAfFileValidateInput } from '@libs/types/src/inbox/input-type/inbox-af-file-validate.input';
import { InboxMessageIdsInput } from '@libs/types/src/inbox/input-type/inbox-message-ids.input';

@Injectable({ providedIn: 'root' })
export class InboxMessageFromAfFileGqlService extends GqlServiceV2 {

    validateAfFile(input: InboxAfFileValidateInput, frag: string): Promise<InboxAfFileValidationResultObject> {
        return this.mutate(`
            mutation($input: InboxAfFileValidateInput!) {
                inboxMessagesFromAfFile {
                    validateAfFile(input: $input) {
                        ${frag}
                    }
                }
            }`,
            { input },
        );
    }

    createMessagesFromAfFile(input: InboxMessageIdsInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxMessageIdsInput!) {
                inboxMessagesFromAfFile {
                    createMessagesFromAfFile(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
